
<template>
  <div class="alarm">
    <div class="main-top">
      <img src="../assets/img/main-title.jpg" alt="" />
    </div>
    <div class="main-content">
      <div class="main-title">
        <h1>系统简介</h1>
      </div>
      <div class="main-summary">
        <div class="summary-img">
          <img src="../assets/img/alarmmain.png" alt="" />
        </div>
        <div class="summary-text">
          <p>
            该系统通过对采集的电源设备实时运行数据、基站配置数据，结合历史运行数据和故障记录进行深度挖掘分析，用智能算法分析得出基站电源设备隐患，并输出维修及调度的指引，
            <b>实现智能主动预警、科学调度。</b>
          </p>
        </div>
      </div>
      <div class="main-title">
        <h1>核心功能</h1>
      </div>
      <div class="main-function">
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/powerguarantee.png" alt="" />
          </div>
          <div>基站电力保障</div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/switchconfig.png" alt="" />
          </div>
          <div>开关电源模块配置</div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/batterymonitor.png" alt="" />
          </div>
          <div>优化蓄电池管理及监测</div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/equipmentdanger.png" alt="" />
          </div>
          <div>设备隐患综合分析</div>
        </div>
      </div>
      <div class="main-title">
        <h1>效果综述</h1>
      </div>
      <div class="alarm-summary">
        <ul class="summary-tip">
          <li>
            提升基站电力保障能力，提高基站服务能力。科学监控、分析、预警、维护，减少故障发生和事后处置，降低日常维护成本
          </li>
          <li>
            满足更高标准的站址电力保障要求和精细、精准、差异化的服务要求，有效提升基站资产配置水平、利用率和运行质量
          </li>
          <li>
            助力提升更精准的隐患发现及差异化整治能力、更科学的维修及调度、更强大的应急保障能力建设
          </li>
        </ul>
        <div class="summary-img">
          <img src="../assets/img/alarmsummary.png" alt="" />
        </div>
      </div>
      <div class="gotoalarm" @click="goto">进入体验></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      map: {},
    };
  },
  mounted() {},
  methods: {
    goto() {
      window.open("http://weipucomm.cn:8080/");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.alarm {
  background-color: #f7f7f7;
  .main-top {
    margin: 1vh 0 0 0;
    height: 13vh;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .main-content {
    margin: 0 5vw;
    .main-title {
      border-bottom: 1px solid #ecedf1;
      overflow: hidden;
      height: 100px;
      h1 {
        background: url(../assets/img/red-line.png) no-repeat center bottom;
        font-weight: 700;
        width: 160px;
        line-height: 100px;
        margin: 0;
      }
    }
    .main-summary {
      display: flex;
      align-items: stretch;
      .summary-img {
        padding: 5vh 0;
        width: 20vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .summary-text {
        padding: 0 0 0 2vw;
        flex: 1;
        p {
          text-indent: 28px;
          line-height: 40px;
          font-size: 20px;
        }
      }
    }
    .main-function {
      display: flex;
      padding: 5vh 0;
      justify-content: space-around;
      .func-item {
        width: 15vw;
        height: 20vw;
        display: flex;
        flex-flow: column;
        align-items: center;
        .function-img {
          height: 15vw;
          width: 15vw;
          img {
            height: auto;
            width: 100%;
          }
        }
        div {
          text-align: center;
          font-size: 24px;
          height: 30%;
          width: 100%;
        }
      }
    }
    .alarm-summary {
      display: flex;
      padding: 5vh 0;
      justify-content: space-around;
      .summary-tip {
        width: 50%;
        font-size: 20px;
        line-height: 35px;
      }
      .summary-img {
        width: 50%;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .gotoalarm {
      text-align: center;
      font-size: 30px;
      color: #dd4242;
      text-decoration: underline;
      line-height: 70px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/alarm.vue